var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-simple-table',[(_vm.value)?_c('tbody',[_c('tr',[_c('th',[_vm._v("Name")]),_c('td',[_vm._v(_vm._s(_vm.value.name))])]),_c('tr',[_c('th',[_vm._v("Abbreviation")]),_c('td',[_vm._v(_vm._s(_vm.value.abbreviation))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }